
document.addEventListener('DOMContentLoaded', function() {
  const stickyBanner = document.querySelector('.trellis-sticky-add-to-cart');
  const addToCartHolder = document.querySelector('#AddToCart');

  const header = document.querySelector('.header-section');
  let headerHeight = 0;

  // Get the height of the header
  if (header) {
    headerHeight = header.offsetHeight;
  }
  
  if (!stickyBanner && !addToCartHolder) return;

  // If the user is logged out show the stickyBanner by default
  if (!addToCartHolder) {
    stickyBanner.style.bottom = '0px';
  } else {
    // If the user is logged in, create intersection observer so the stickyBanner is only visible when the ATC button is out of view
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // add_to_cart_holder is visible, hide sticky banner
          stickyBanner.style.bottom = '-150px';
        } else {
          // add_to_cart_holder is not visible, show sticky banner
          stickyBanner.style.bottom = '0px';
        }
      });
    }, {
      // Trigger when the element is completely out of view
      threshold: 0,
      rootMargin: `-${headerHeight}px 0px 0px`
    });
    
    // Start observing the add_to_cart_holder
    observer.observe(addToCartHolder);
  }
});
